import { IS_QUIZ } from "./actionTypes";

export const isQuiz = (type) => {
  return {
    type: IS_QUIZ,
    payload: type,
  };
};
